module.exports = __webpack_public_path__ + "fac3a19bbed393ffc20c8403d845f315.png";